export enum MaterialUnit {
  UNIT = 'unit',
  LB = 'lb',
}
